"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ProfileMenu = function ProfileMenu(_ref) {
  var classes = _ref.classes,
      currentOffice = _ref.currentOffice,
      logout = _ref.logout,
      offices = _ref.offices,
      setCurrentOffice = _ref.setCurrentOffice;

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
    document.getElementById("expandMore").classList.remove(classes.expandOpen);
  };

  var handleExpandClick = function handleExpandClick(event) {
    var multiOfficeExpandElement = document.getElementById("expandMore").classList.value;

    if (multiOfficeExpandElement.indexOf("expandOpen") === -1) {
      document.getElementById("expandMore").classList.add(classes.expandOpen);
    }

    handleClick(event);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "aria-owns": anchorEl ? "profile-menu" : undefined,
    "aria-haspopup": "true",
    variant: "contained",
    color: "primary",
    onClick: handleExpandClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.profileIcon
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "user-circle"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.officeName
  }, currentOffice.officeName), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    id: "expandMore",
    className: classes.officeSwitcherIcon
  }))), /*#__PURE__*/_react["default"].createElement(_core.Menu, {
    id: "profile-menu",
    classes: {
      paper: classes.profileMenu
    },
    elevation: 0,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    key: "placeholder",
    style: {
      display: "none"
    }
  }), offices && offices.map(function (office) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      onClick: function onClick() {
        setCurrentOffice(office);
        handleClose();
      },
      key: office.officeName,
      selected: office.officeId === currentOffice.officeId
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      primary: office.officeName
    }));
  }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    onClick: function onClick() {
      logout();
      handleClose();
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: "Logout"
  }))));
};

ProfileMenu.propTypes = {
  classes: _propTypes["default"].object,
  currentOffice: _propTypes["default"].object,
  logout: _propTypes["default"].func,
  offices: _propTypes["default"].array,
  setCurrentOffice: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(_styles2["default"])(ProfileMenu);

exports["default"] = _default;